import React from 'react';
import styles from './nba-tag.module.scss';
import { CdnImg } from '@/features/cdn-img';
import clsx from 'clsx';
interface NBATagProps {
  className?: string;
  size?: 'normal' | 'small';
}

export const NBATag: React.FC<NBATagProps> = ({ className, size = 'normal' }) => {
	const imageSrc = size === 'normal' ? '/images/promotion/golden-duel/n-nba-tag.png' : '/images/promotion/golden-duel/s-nba-tag.png';
	return (
		<div className={clsx(className, size === 'normal' ? styles.rootN : styles.rootS)}>
			<CdnImg 
				src={imageSrc}
				alt="NBA Logo"
			/>
			<div className={styles.shiningLine} />
		</div>
	);
}; 